<!--
component: MapPane
author: Ken Nakamura
description: 地図検索画面
-->
<template>
	<body style="height: 100%;">

		<!-- データ入力時の台帳参照ウィンドウ -->
		<container class="scroll-container" style="width: 100%; height: calc(100% - 115px);">
			<div class="scroll-container" ref="container" @wheel.prevent="handleWheel" style="width: 100%; height: 100%;">
				<div class="image-wrapper" :style="{ transform: `translate(${translateX}px, ${translateY}px) scale(${scale})` }" style="width: 100%; height: 100%;">
					<img :src="imageUrl" alt="Image" class="full-width-image" ref="image" @mousedown="handleMouseDown" @mousemove="handleMouseMove" @mouseup="handleMouseUp" @mouseleave="handleMouseUp">
				</div>
			</div>
		</container>
		<!--
		<container class="scroll-container">
			<div style="width: 100%; border: 1px solid #808080;" class="image-wrapper">
				<img :src="imageUrl" :style="{ transform: `scale(${zoomFactor})` }" alt="Image" class="full-width-image" ref="image">
			</div>
		</container>
		-->

		<!-- 操作・入力項目 -->
		<div style="display: flex; justify-content: center; width: 100%;">	
			<!-- 操作ボタン -->
			<container class="button-background" style="margin-bottom: 3px;">
				<!--
				<div class="button-container">
					<button class="action-button">
						中心
					</button>
					<button class="action-button" @click="zoom_up">
						拡大
					</button>
					<button class="action-button" @click="zoom_down">
						縮小
					</button>
					<button class="action-button">
						移動
					</button>						
				</div>
				-->

				<div class="button-container">
					<button class="action-button" @click="goto_before_image" :disabled="!isBeforeImage">
						前画像
					</button>
					<button class="action-button" @click="goto_next_image" :disabled="!isNextImage">
						次画像
					</button>
				</div>

				<div class="button-container">
					<button class="action-button" @click="rotateLeft">
						左回転
					</button>
					<button class="action-button" @click="rotateRight">
						右回転
					</button>
				</div>

				<div class="button-container">
					<!--
					<button class="action-button" @click="toggleFullScreen">
						全画面表示
					</button>
					-->
					<button class="action-button" @click="printImage">
						画像印刷
					</button>
				</div>
			</container>

			<!-- 全画面表示用のダイアログ -->
			<!--
			<div v-if="isFullScreen" class="fullscreen-dialog" @keydown.esc="exitFullScreen" tabindex="0">
				<div class="fullscreen-content">
					<img :src="imageUrl" alt="Your Image" class="fullscreen-image" ref="fullscreenImage">
					<button @click="exitFullScreen">終了</button>
				</div>
			</div>
			-->
		</div>
		
		<!-- 操作・入力項目 ここまで -->

		<Dialog error :open="authDialog" :ok="() => authDialog = false" :to="'/'" title="ユーザー認証"
			body="ユーザー認証に失敗しました。ログインし直して下さい。" />
	</body>
</template>
  
<script>
//import MapComponent from '../components/Map.vue'
import { apiUrl, dbglog, gaiyoURL, /*elvUrl,*/ plotUrl, plotUrlAlt, daichoIMG } from '../common/utils'
import constants from '../common/constants'
import { callGetApi } from '../common/apiAccess'
import Dialog from '../components/Dialog.vue'

export default {
	data() {
		return {
      isCheckedBox: [false, false] ,
			scalevisible: false,
			existsGaiyo: false,
			plotUrl: '',
			plotUrlAlt: '',
			plotDef: null,
			plotDefAlt: null,
			sheetUrl: '',
			nendoList: [],
			bgmapList: [],
			queryingSheet: false,
			nendoCols: 12,
			nendoXlCols: 6,
			textClass: 'text-h6',
			targetPlotData: this.targetPlot,
			selectedLayer: '',
			// swipe用変数
			position: 0,
			moveX: 0,
			width: 0,
			authDialog: false,
			unit_site_area: 'option1',
			unit_bld_area: 'option1',
			inputAboveGroundFloors: '',
			inputBelowGroundFloors: '',
			inputNumberOfBuildings: '',

			//------------------------------------
			// 2023/12/26
			// 値を表示
			sikibetsu: "55鶴8",
			flg_data_kakutei: "",
			flg_data_kknnzumi: "",
			uke_day: "",
			kknn_day: "",
			bldr_addr1: "",
			bldr_addr2: "",
			bldr_name1: "",
			bldr_name2: "",
			bldr_other_cnt: "",
			bkn_addr1: "",
			bkn_addr2: "",
			syuyo_yoto: "",
			gutai_syuyo_yoto: "",
			koji_sybt: "",
			kozo_sybt: "",
			tijo_kaisu: "",
			tika_kaisu: "",
			sns_bld_su: "",
			site_area: "",
			bld_area: "",
			nb_area: "",
			unit_nb_area: "",
			kenzumi_day: "",
			flg_kenzumi: "",
			stop_sybt: "",
			stop_day: "",
			biko1: "",
			biko2: "",
			biko3: "",
			biko4: "",
			tekiyo: "",
			annotation: "",

			// 画像表示URL
			imageUrl: "",
			rotationAngle: 0,
			isFullScreen: false,

			isReadOnly: true,
			zoomFactor: 1.0,
			//------------------------------------
			isBeforeImage: false,
			isNextImage: false,
			//------------------------------------
			// Zoom
			isDragging: false,
			startX: 0,
			startY: 0,
			translateX: 0,
			translateY: 0,
			scale: 1,
		}
	},
	components: {
		//    MapComponent,
		Dialog,
	},
	props: {
		zoom: {
			type: Number,
			default: 18,
		},
		targetPlot: {
			type: Object,
			default: null,
		},
	},
	created() {
		this.plotUrl = plotUrl();
		this.plotUrlAlt = plotUrlAlt();
		this.plotDef = constants.tileDef[this.mode];
		if (this.mode == 5) {
			this.plotDefAlt = constants.tileDef[6];
		}
		dbglog('MapPane:' + this.plotDef);
		if (this.sheetVisible) {
			if (this.mode == 1) {
				this.sheetUrl = this.$store.state.mapOrigin + constants.tileDef[8].url;
			}
			else if (this.mode == 5) {
				this.sheetUrl = this.$store.state.mapOrigin + constants.tileDef[9].url;
			}
		}
		if (this.mode == 7) {
			///*
			this.bgmapList = [
				this.$store.state.mapOrigin + constants.tileDef[10].url,
				this.$store.state.mapOrigin + constants.tileDef[11].url,
			];
			//*/
			/*
			this.bgmapList = [];
			if (this.$store.state.seibiSokushinVisible) {
				this.bgmapList.push(this.$store.state.mapOrigin + constants.tileDef[10].url);
			}
			if (this.$store.state.douroShubetsuVisible) {
				this.bgmapList.push(this.$store.state.mapOrigin + constants.tileDef[11].url);
			}
			*/
		}
	},
	mounted() {
		if (this.unauthorized) {
			this.message = 'ユーザー認証されていません。';
			this.$router.replace('/');
		}
		this.$store.commit('setCurrentPage', 5);
		this.message = '';
		//選択されているプロットの番号が保存されている場合
		if (this.selectedNo) {
			this.searchGaiyo(this.selectedNo, (data) => {
				this.existsGaiyo = (data && data.length);
			});
		}

		//------------------------------------
		// 2023/12/26
		// 値を表示
		this.dispItemData();
		//------------------------------------

		//this.targetPlotData = this.targetPlot; //ここでは遅い
		//test
		//console.log(this.targetPlot);
	},
	computed: {
		token() {
			return this.$store.state.token;
		},
		unauthorized() {
			return this.token == undefined || this.token == null || this.token.length == 0;
		},
		authorized() {
			return !this.unauthorized;
		},
		message: {
			get() { return this.$store.state.message; },
			set(val) { this.$store.commit('setMessage', val); }
		},
		browsable() {
			return this.isSelected && this.existsGaiyo;
		},
		features: {
			get() { return this.$store.state.features; },
			set(val) { this.$store.commit('setFeatures', val); }
		},
		sheets: {
			get() { return this.$store.state.sheets; }
		},
		mode() {
			return this.$store.state.mode;
		},
		authority() {
			//return this.$store.state.authority;
			return this.$store.state.userInfo.authority;
		},
		sheetVisible() {
			//return (this.authority >= 1) && (this.mode == 1 || this.mode == 5);
			// authority=4 は住所検索と番号検索のみ（仮）
			return (this.authority >= 1 && this.authority != 4) && (this.mode == 1 || this.mode == 5);
		},
		douroShubetsuVisible: {
			get() {
				return this.$store.state.douroShubetsuVisible;
			},
			set(val) {
				this.$router.commit('setDouroShubetsuVisible', val);
			}
		},
		gaiyoId() {
			return this.$store.state.gaiyoId;
		},
		gaiyo() {
			return this.$store.state.gaiyoData;
		},
		selectedNo: {
			get() { return this.$store.state.selectedNo; },
			set(val) { this.$store.commit('setSelectedNo', val); }
		},
		selectedId: {
			get() { return this.$store.state.selectedId; },
			set(val) { this.$store.commit('setSelectedId', val); }
		},
		gaiyoList() {
			return this.$store.state.gaiyoList;
		},
		centerx() {
			return this.$store.state.centerx;
		},
		centery() {
			return this.$store.state.centery;
		},
		selectedPlotTitle() {
			let title = this.plotDef.title;
			if (this.plotDefAlt)
				title += '・' + this.plotDefAlt.title;
			return title;
		},
		browseButtonTitle() {
			if (this.mode == 1) {
				return '概要書を閲覧';
			}
			else if (this.mode == 2) {
				return '昇降機台帳を閲覧';
			}
			else if (this.mode == 3) {
				return '定期報告概要書を閲覧';
			}
			else if (this.mode == 5) {
				if (this.selectedLayer == 'vectorLayer')
					return '開発登録簿を閲覧';
				else if (this.selectedLayer == 'vectorLayerAlt')
					return '造成計画平面図を閲覧';
				else
					return '閲覧';
			}
			else {
				return '閲覧';
			}
		},
		isSelected() {
			return this.selectedNo !== undefined && this.selectedNo !== null
				&& this.selectedNo != '';
		},
		wardCode() {
			return this.$store.state.wardCode;
		},
		wardName() {
			return this.$store.state.wardName;
		},
		townCode() {
			return this.$store.state.townCode;
		},
		townName() {
			return this.$store.state.townName;
		},
		oyaban() {
			return this.$store.state.oyaban;
		},
		edaban() {
			return this.$store.state.edaban;
		},
		bottomSheet() {
			return ((this.$store.state.features.length > 0) && (this.$vuetify.breakpoint.name == 'xs'));
		}
	},
	watch: {
		features(newValue, oldValue) {
			dbglog(`MapPane: watch.features(${newValue},${oldValue})`, 2);
			if (newValue != null) {
				if (newValue.length == 0 || newValue.length > 1) {
					this.selectedId = '';
					this.selectedNo = '';
					this.selectedLayer = '';
				}
				else if (newValue.length == 1) {
					this.selectRow(newValue[0]);
				}
			}
		},
		sheets(newValue, oldValue) {
			if ((newValue != oldValue) && !this.queryingSheet) {
				const ku = this.wardCode - 14100;
				let sheets = '';
				for (let i = 0; i < newValue.length; i++) {
					sheets += (sheets.length > 0 ? ',' : '') + newValue[i].indexId;
				}
				let url = '';
				if (this.mode == 1) {
					url = apiUrl('KenkakuPlotIndexNendo') + `?ku=${ku}&sheets=${sheets}`;
				}
				else if (this.mode == 5) {
					url = apiUrl('KaihatsuPlotIndexNendo') + `?ku=${ku}&sheets=${sheets}`;
				}
				else {
					return;
				}
				this.queryingSheet = true;
				callGetApi(url, (data) => {
					this.nendoList = [];
					if (data.length) {
						if (data.length > 10) {
							this.nendoCols = 6;
							this.nendoXlCols = 4;
							this.textClass = 'text-h7';
						}
						else {
							this.nendoCols = 12;
							this.nendoXlCols = 6;
							this.textClass = 'text-h6';
						}
						for (let i = 0; i < data.length; i++) {
							for (let j = 0; j < newValue.length; j++) {
								if (data[i].id == newValue[j].indexId) {
									this.nendoList.push({
										id: data[i].id,
										name: data[i].name,
										pageNo: newValue[j].pageNo,
										branch: newValue[j].branch
									});
									break;
								}
							}
						}
					}
					this.queryingSheet = false;
				});
			}
		},
	},
	methods: {
		printImage() {
			const url = this.getImageURL();
			const rotationAngle = this.rotationAngle;

			var printFrame = document.createElement('iframe');
			printFrame.style.display = 'none';

			printFrame.onload = function() {
				var imageContainer = printFrame.contentDocument.querySelector('div');
        imageContainer.style.display = 'flex';
        imageContainer.style.margin = 0;
        imageContainer.style.justifyContent = 'center';
        imageContainer.style.alignItems = 'center';
        imageContainer.style.height = '100vh';
        //imageContainer.style.width = '100%';
        //imageContainer.style.height = '100%';

				//var style = printFrame.contentDocument.createElement('style');
				//style.innerHTML = '@media print { @page { size: landscape; } }';
				//printFrame.contentDocument.head.appendChild(style);

				var image = printFrame.contentDocument.querySelector('img');
				image.style.maxWidth = '100%';
        image.style.maxHeight = '100%';
        image.style.transform = `rotate(${rotationAngle}deg)`;

				// ページ読み込み完了後に印刷を開始します
				printFrame.contentWindow.print();
				document.body.removeChild(printFrame);
			};

			document.body.appendChild(printFrame);

			printFrame.contentDocument.write('<html><head><title>Print Image</title></head><body style="margin: 0; text-align: center;"><div><img src="' + url + '" style="max-width: 100%; max-height: 100%;"></div></body></html>');
			printFrame.contentDocument.close();
		},
		zoom_up() {
			this.zoomFactor += 0.1;
    },
		zoom_down() {
			this.zoomFactor -= 0.1;
    },
    rotateRight() {
      this.rotationAngle += 90;
      this.rotateImage();
    },
    rotateLeft() {
      this.rotationAngle -= 90;
      this.rotateImage();
    },
    rotateImage() {
      const image = this.$refs.image;
			//const wrapper = image.parentElement;

			//this.adjustImageSize(image, wrapper);
      image.style.transform = `rotate(${this.rotationAngle}deg)`;
    },
    adjustImageSize(image, wrapper) {
      if (this.rotationAngle % 180 === 90) {
        wrapper.style.width = `${image.clientHeight}px`;
        wrapper.style.height = `${image.clientWidth}px`;
      } else {
        wrapper.style.width = '';
        wrapper.style.height = '';
      }
    },
    toggleFullScreen() {
      this.isFullScreen = true;
    },
    exitFullScreen() {
      this.isFullScreen = false;
    },
		goto_first() {
			var sel_index = 0;
			this.$store.commit('setSeldaichoindex', sel_index);
			this.dispItemData();
		},
		goto_before() {
			var sel_index = this.$store.state.seldaichoIndex - 1;
			if (sel_index < 0) sel_index = 0;
			this.$store.commit('setSeldaichoindex', sel_index);
			this.dispItemData();
		},
		goto_next() {
			var daicho_list = this.$store.state.daicho;
			var sel_index = this.$store.state.seldaichoIndex + 1;
			if (sel_index >= daicho_list.length) sel_index = daicho_list.length - 1;
			this.$store.commit('setSeldaichoindex', sel_index);
			this.dispItemData();
		},
		goto_last() {
			var daicho_list = this.$store.state.daicho;
			var sel_index = sel_index = daicho_list.length - 1;
			this.$store.commit('setSeldaichoindex', sel_index);
			this.dispItemData();
		},
		goto_print() {
			this.$router.push('kamisearchresultprint');
		},
		makeImagePostData(item, uke_kubun) {
			console.log(item);
			var postData = {};
//			var daicho_search = this.$store.state.daichoSearch;

			postData.uke_kubun = uke_kubun;
			postData.uke_day = item.uke_day;
//			postData.gengo = getWarekiCode(daicho_search.gengo);
//			postData.nen = daicho_search.nen;
//			postData.nen_kubun = daicho_search.nen_kubun;
//			postData.gyosei_kubun = getWardCode(daicho_search.gyosei_kubun);
//			postData.bango = daicho_search.bango;
//			postData.branch = daicho_search.branch;

			postData.gengo = item.gengo;
			postData.nen = item.nen;
			postData.nen_kubun = item.nen_kubun;
			postData.gyosei_kubun = item.gyosei_kubun;
			postData.bango = item.bango;
			postData.branch = item.branch;

			return (postData);
		},
		makePostData() {
			var daicho_list = this.$store.state.daicho;
			var daicho_index = this.$store.state.seldaichoIndex;

			//			var daicho_item = this.$store.state.seldaicho;
			var daicho_item = daicho_list[daicho_index];

			var postData = {};

			//postData.id = daicho_item.id.trim();
			postData.id = daicho_item.id;
			daicho_item.flg_data_kakutei = postData.flg_data_kakutei = this.flg_data_kakutei;
			daicho_item.flg_data_kknnzumi = postData.flg_data_kknnzumi = this.flg_data_kknnzumi;
			daicho_item.uke_day = postData.uke_day = this.uke_day;
			daicho_item.kknn_day = postData.kknn_day = this.kknn_day;
			daicho_item.bldr_addr1 = postData.bldr_addr1 = this.bldr_addr1;
			daicho_item.bldr_addr2 = postData.bldr_addr2 = this.bldr_addr2;
			daicho_item.bldr_name1 = postData.bldr_name1 = this.bldr_name1;
			daicho_item.bldr_name2 = postData.bldr_name2 = this.bldr_name2;
			daicho_item.bldr_other_cnt = postData.bldr_other_cnt = this.bldr_other_cnt;
			daicho_item.bkn_addr1 = postData.bkn_addr1 = this.bkn_addr1;
			daicho_item.bkn_addr2 = postData.bkn_addr2 = this.bkn_addr2;
			daicho_item.syuyo_yoto = postData.syuyo_yoto = this.syuyo_yoto;
			daicho_item.gutai_syuyo_yoto = postData.gutai_syuyo_yoto = this.gutai_syuyo_yoto;
			daicho_item.koji_sybt = postData.koji_sybt = this.koji_sybt;
			daicho_item.kozo_sybt = postData.kozo_sybt = this.kozo_sybt;
			daicho_item.tijo_kaisu = postData.tijo_kaisu = this.tijo_kaisu;
			daicho_item.tika_kaisu = postData.tika_kaisu = this.tika_kaisu;
			daicho_item.sns_bld_su = postData.sns_bld_su = this.sns_bld_su;
			daicho_item.site_area = postData.site_area = this.site_area;
			daicho_item.unit_site_area = postData.unit_site_area = this.unit_site_area;
			daicho_item.bld_area = postData.bld_area = this.bld_area;
			daicho_item.unit_bld_area = postData.unit_bld_area = this.unit_bld_area;
			daicho_item.nb_area = postData.nb_area = this.nb_area;
			daicho_item.unit_nb_area = postData.unit_nb_area = this.unit_nb_area;
			daicho_item.kenzumi_day = postData.kenzumi_day = this.kenzumi_day;
			daicho_item.flg_kenzumi = postData.flg_kenzumi = this.flg_kenzumi;
			daicho_item.stop_sybt = postData.stop_sybt = this.stop_sybt;
			daicho_item.stop_day = postData.stop_day = this.stop_day;
			daicho_item.biko1 = postData.biko1 = this.biko1;
			daicho_item.biko2 = postData.biko2 = this.biko2;
			daicho_item.biko3 = postData.biko3 = this.biko3;
			daicho_item.biko4 = postData.biko4 = this.biko4;
			daicho_item.tekiyo = postData.tekiyo = this.tekiyo;
			daicho_item.annotation = postData.annotation = this.annotation;

			return (postData);
		},
		goto_before_image() {
			var daicho_list = this.$store.state.daichoImage;
			var sel_index = this.$store.state.seldaichoImageIndex - 1;
			var sel_mode = 5;

			for (var i = sel_index; i >= 0; i--) {
				if(daicho_list[i].uke_kubun == sel_mode){
					sel_index = i;
					break;
				}
			}

			this.$store.commit('setDaichoimageindex', sel_index);
			this.setPrintNextBeforeButton();
			this.dispImageData();
		},
		goto_next_image() {
			var daicho_list = this.$store.state.daichoImage;
			var sel_index = this.$store.state.seldaichoImageIndex + 1;
			var sel_mode = 5;

			for (var i = sel_index; i < daicho_list.length; i++) {
				if(daicho_list[i].uke_kubun == sel_mode){
					sel_index = i;
					break;
				}
			}

			this.$store.commit('setDaichoimageindex', sel_index);
			this.setPrintNextBeforeButton();
			this.dispImageData();
		},
		getImageURL() {
			//var sel_mode = this.$store.state.seldaichoImageMode;
			var sel_index = this.$store.state.seldaichoImageIndex;
			var data = this.$store.state.daichoImage[sel_index];

			var folder = data.folder;
			var file_name = data.file_name.replace(".tif", '.png');
			var url = "";
			if(folder == ""){
				return url;
			}

			console.log('####### getImageURL');
			if(data.uke_kubun == 5){
				folder = folder.replace(/\\/g, "/");
				console.log(folder);
				console.log(file_name);
				url = this.$store.state.daichoOrigin + `${encodeURIComponent(folder)}/${encodeURIComponent(file_name)}`;
			} else {
				console.log(folder);
				console.log(file_name);
				url = this.$store.state.mapOrigin + `daicho/${encodeURIComponent(folder)}/${encodeURIComponent(file_name)}`;
			}
			console.log(url);

      this.currentFileName = file_name;
			return url;
		},
		dispImageData() {
			const url = this.getImageURL();
			if(url != ""){
				this.imageUrl = url;
			}
		},
		checkImageExists(data) {
			var url = "";
			var folder = data.folder;
			var file_name = data.file_name.replace(".tif", '.png');

			console.log('####### checkImageExists');
			if(data.uke_kubun == 5){
				folder = folder.replace(/\\/g, "/");
				console.log(folder);
				console.log(file_name);
				url = this.$store.state.daichoOrigin + `${encodeURIComponent(folder)}/${encodeURIComponent(file_name)}`;
			} else {
				console.log(folder);
				console.log(file_name);
				url = this.$store.state.mapOrigin + `daicho/${encodeURIComponent(folder)}/${encodeURIComponent(file_name)}`;
			}

			var http = new XMLHttpRequest();
			http.open('HEAD', url, false); // 同期的なリクエストを行う
			http.send();
			//return http.status === 200 && http.getResponseHeader('Content-Type').indexOf('image') !== -1;
			return http.status === 200;
		},
		setPrintNextBeforeButton() {
			var daicho_list = this.$store.state.daichoImage;
			var sel_index = this.$store.state.seldaichoImageIndex;
			var sel_mode = 5;

			var min_v = 100;
			var max_v = -1;
			for (var i = 0; i < daicho_list.length; i++) {
				if(daicho_list[i].uke_kubun == sel_mode){
					if(min_v > i) min_v = i;
					if(max_v < i) max_v = i;
				}
			}
			if (sel_index <= min_v) {
				this.isBeforeImage = false;
			}else {
				this.isBeforeImage = true;
			}
			if(sel_index < max_v) {
				this.isNextImage = true;
			}else{
				this.isNextImage = false;
			}
		},
		getImageData(daicho_item, uke_kubun) {
			// 画像表示
			var value = this.makeImagePostData(daicho_item, uke_kubun);
			console.log(value);

			var url = daichoIMG() + `/Search`;
			fetch(url, {
				mode: 'cors',
//				method: 'GET',
				method: 'POST',
				headers: {
					'Authorization': 'Bearer ' + this.token,
					'Content-Type': 'application/json',
				},
				body: JSON.stringify(value)
			})
				.then((response) => {
					dbglog(response);
					if (response.ok) {
						return response.json();
					} else {
						return response.status;
					}
				})
				.then((data) => {
					dbglog(data);
					console.log(data);
					var uke_kubun = 0;
					for (var i = 0; i < data.length; i++) {
						if(data[i].uke_kubun == 1){
							data[i].file_name = data[i].file_name.replace('.tif', '.png');
							if(this.checkImageExists(data[i])) {
								this.isShiDaicho = true;
								if(uke_kubun == 0) uke_kubun = 1;
							} else  {
								data[i].uke_kubun = -1;
								data[i].folder = '';
								data[i].file_name = '';
							}
						}	else if(data[i].uke_kubun == 2){
							data[i].file_name = data[i].file_name.replace('.tif', '.png');
							if(this.checkImageExists(data[i])) {
								this.isKuDancho = true;
								if(uke_kubun == 0) uke_kubun = 2;
							} else  {
								data[i].uke_kubun = -1;
								data[i].folder = '';
								data[i].file_name = '';
							}
						}	else if(data[i].uke_kubun == 3){
							data[i].file_name = data[i].file_name.replace('.tif', '.png');
							if(this.checkImageExists(data[i])) {
								this.iskeiDaicho = true;
								if(uke_kubun == 0) uke_kubun = 3;
							} else  {
								data[i].uke_kubun = -1;
								data[i].folder = '';
								data[i].file_name = '';
							}
						}	else if(data[i].uke_kubun == 4){
							data[i].file_name = data[i].file_name.replace('.tif', '.png');
							if(this.checkImageExists(data[i])) {
								this.isBunDaicho = true;
								if(uke_kubun == 0) uke_kubun = 4;
							} else  {
								data[i].uke_kubun = -1;
								data[i].folder = '';
								data[i].file_name = '';
							}
						}	else if(data[i].uke_kubun == 5){
							var copy_obj = null;
							data[i].file_name = data[i].file_name.replace('.tif', '-0.png');
							var orig_copy_obj = Object.assign({}, data[i]);
							if(this.checkImageExists(data[i])) {
								this.isGaiyosho = true;
								if(uke_kubun == 0) uke_kubun = 5;
							} else  {
								data[i].uke_kubun = -1;
								data[i].folder = '';
								data[i].file_name = '';
							}

							copy_obj = Object.assign({}, orig_copy_obj);
							copy_obj.file_name = copy_obj.file_name.replace('-0.png', '-1.png');
							if(this.checkImageExists(copy_obj)) {
								this.isGaiyosho = true;
								if(uke_kubun == 0) uke_kubun = 5;
								data.push(copy_obj);
							} else  {
								copy_obj.uke_kubun = -1;
								copy_obj.folder = '';
								copy_obj.file_name = '';
							}
							
							copy_obj = Object.assign({}, orig_copy_obj);
							copy_obj.file_name = copy_obj.file_name.replace('-0.png', '-2.png');
							if(this.checkImageExists(copy_obj)) {
								this.isGaiyosho = true;
								if(uke_kubun == 0) uke_kubun = 5;
								data.push(copy_obj);
							} else  {
								copy_obj.uke_kubun = -1;
								copy_obj.folder = '';
								copy_obj.file_name = '';
							}
							
							copy_obj = Object.assign({}, orig_copy_obj);
							copy_obj.file_name = copy_obj.file_name.replace('-0.png', '-3.png');
							if(this.checkImageExists(copy_obj)) {
								this.isGaiyosho = true;
								if(uke_kubun == 0) uke_kubun = 5;
								data.push(copy_obj);
							} else  {
								copy_obj.uke_kubun = -1;
								copy_obj.folder = '';
								copy_obj.file_name = '';
							}
							
							copy_obj = Object.assign({}, orig_copy_obj);
							copy_obj.file_name = copy_obj.file_name.replace('-0.png', '-4.png');
							if(this.checkImageExists(copy_obj)) {
								this.isGaiyosho = true;
								if(uke_kubun == 0) uke_kubun = 5;
								data.push(copy_obj);
							} else  {
								copy_obj.uke_kubun = -1;
								copy_obj.folder = '';
								copy_obj.file_name = '';
							}
							
							copy_obj = Object.assign({}, orig_copy_obj);
							copy_obj.file_name = copy_obj.file_name.replace('-0.png', '-5.png');
							if(this.checkImageExists(copy_obj)) {
								this.isGaiyosho = true;
								if(uke_kubun == 0) uke_kubun = 5;
								data.push(copy_obj);
							} else  {
								copy_obj.uke_kubun = -1;
								copy_obj.folder = '';
								copy_obj.file_name = '';
							}
							break;
						}
					}

					var sel_index = 0;
					var sel_mode = 5;

					for (var ii = sel_index; ii < data.length; ii++) {
						if(data[ii].uke_kubun == sel_mode){
							sel_index = ii;
							break;
						}
					}

					this.$store.commit('setDaichoimage', data);
					this.$store.commit('setDaichoimageMode', sel_mode);
					this.$store.commit('setDaichoimageindex', sel_index);
					this.setPrintNextBeforeButton();
					this.dispImageData();
				})
				.catch((err) => {
					dbglog(`Address.vue.searchChiban(): ${err}`);

				});
		},
		setReadOnly(flag) {
			this.isReadOnly = flag;
		},
		editable() {
			this.setReadOnly(false);
		},
		cancel() {
			this.dispItemData();
			this.setReadOnly(true);
		},
		dispItemData() {
			var daicho_list = this.$store.state.daicho;
			var daicho_index = this.$store.state.seldaichoIndex;

			//			var daicho_item = this.$store.state.seldaicho;
			var daicho_item = daicho_list[daicho_index];
			console.log(daicho_item);

			// 画像表示
			this.getImageData(daicho_item,null);
		},
		floorInput(field) {
			this.convertToHalfWidth(field);
			this.validateInput(field);
		},

		convertToHalfWidth(field) {
			this[field] = this[field].replace(/[０-９]/g, function (s) {
				return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
			});
		},

		validateInput(field) {
			this[field] = this[field].replace(/[^0-9-]/g, '');
		},


		plotKey(layerFeature) {
			const k = layerFeature.feature ?? layerFeature;
			let result = k.get(this.plotDef.key);
			if (this.plotDefAlt !== null) {
				//if (result === undefined || result === null || result.length === undefined || result.length == 0) {
				if (!result) {
					result = k.get(this.plotDefAlt.key);
				}
			}
			return result;
		},
		isSelectedRow(k) {
			//const layer = k.layer;
			const feature = k.feature;
			const no = this.plotKey(feature);
			//const selNo = this.selectedNo;
			const selNo = this.selectedId;
			const hit = (no == selNo)
			//console.log(`k:${no} sel:${selNo} hit:${hit}`)
			return hit;
		},
		plotLabel(k) {
			const layer = k.layer;
			const feature = k.feature;
			let result = '不明';
			if (layer == 'vectorLayer') {
				result = feature.get(this.plotDef.label);
				if (!result)
					result = feature.get(this.plotDef.key);
			}
			else if (layer == 'vectorLayerAlt') {
				result = feature.get(this.plotDefAlt.label);
				if (!result) {
					result = feature.get(this.plotDefAlt.key);
				}
			}
			return result ?? '';
		},
		setMessage() {
			if (this.targetPlot) {
				this.$store.commit('setMessage', '　');
			}
			else {
				let addrText = `${this.wardName} ${this.townName}`;
				if (this.oyaban > 0) {
					addrText += ` ${this.oyaban}`;
					if (this.edaban > 0) {
						addrText += `-${this.edaban}`;
					}
				}
				this.$store.commit('setMessage', `地図検索：${addrText}`);
			}
		},
		// 呼び出される事がない？
		onMapSelectionChanged(selection) {
			//this.features = selection;
			//this.existsGaiyo = false;
			dbglog(`onMapSelectionChanged(${selection})`, -1);
			if (selection.length == 1) {
				dbglog(`MapPane: onMapSelectionChanged(${selection[0]})`, -1);
				this.selectRow(selection[0]);
			}
		},
		/**
		 * プロット一覧から特定の行を選択状態にする
		 * @param { PlotData } target 選択状態にするプロットデータ
		 */
		selectRow(target) {
			//test
			//this.targetPlotData = target.feature;
			//
			this.selectedLayer = target.layer;
			const selNo = this.plotKey(target);
			let selLabel = this.plotLabel(target);
			// 開発・造成・土石の堆積、指定道路用にSEQをselectedIdに保存
			//this.selectedNo = selNo;
			this.selectedId = selNo;
			this.selectedNo = selLabel;
			//開発・造成・土石の堆積の別を判定
			/*
			if (selNo != selLabel) {
				this.$store.commit('setSearchTargetType', selLabel.includes('規') ? 1 : 0);
			}
			*/
			this.$store.commit('setSearchTargetType', target.layer == 'vectorLayerAlt' ? 1 : 0);
			// 選択された番号の概要書データが存在するか調べて
			// 閲覧ボタンの使用可否を設定する（建築のみ）
			this.searchGaiyo(this.selectedNo, (data) => {
				this.existsGaiyo = (data && data.length);
			});
		},
		selectNendo(nendo) {
			dbglog(` selected: id=${nendo.id}, pageNo=${nendo.pageNo}, branch=${nendo.branch}`);
			this.$store.commit('setIndexId', nendo.id);
			this.$store.commit('setNendoName', nendo.name);
			//プロット地図画面の入力値をクリア
			this.$store.commit('setSearchYear', 0);
			this.$store.commit('setSearchBango', '');
			//
			this.$router.push({ name: 'plot-map', params: { sheet: nendo.pageNo } });
		},
		/**
		 * 現在選択されているプロットの概要書を表示する
		 */
		browse() {
			this.$store.commit('setUkeNo', this.selectedNo);
			this.$store.commit('setGaiyoId', this.selectedId);
			this.$router.push({ name: 'loading', params: { action: 1 } });
		},
		/**
		 * 指定された受付番号のデータを検索する
		 * （リスト選択時に閲覧ボタン使用可否を決定するために呼び出される）
		 * @param {String} ukeNo 受付番号
		 */
		searchGaiyo(ukeNo, callback) {
			if (ukeNo == null || ukeNo.length == 0) {
				this.existsGaiyo = false; //暫定措置
				return;
			}
			this.existsGaiyo = true; //暫定措置

			let url;
			if (this.mode == 1) {
				url = gaiyoURL() + '?uke_no=' + ukeNo;
			}
			else if (this.mode == 2) {
				//url = elvUrl() +  '?uke_no=' + ukeNo;
				return;
			}
			else {
				return;
			}
			dbglog(url);

			fetch(url, {
				mode: 'cors',
				method: 'GET',
				headers: {
					Authorization: 'Bearer ' + this.token,
				},
			})
				.then((response) => {
					dbglog(response);
					if (response.ok) {
						return response.json();
					}
					else {
						return response.status;
					}
				})
				.then((data) => {
					dbglog(data);
					if (data == 401) {
						this.loading = false;
						this.progressMessage = 'ユーザ認証に失敗しました。';
						this.authDialog = true;
						return;
					}
					callback(data);
				})
				.catch((err) => {
					dbglog(`MapPane.vue.searchGaiyo(${ukeNo}): ${err}`);
				});
		},
		onScroll(event) {
			//console.log(event.target.scrollTop);
			if (event.target.scrollTop == 200) {
				//console.log('in');
				document.getElementsByClassName('v-dialog__content')[0].style.height = '90%';
				document.getElementsByClassName('v-dialog__content')[0].style.bottom = '0';
				document.getElementsByClassName('v-dialog__content')[0].style.top = 'revert';
			} else if (event.target.scrollTop == 0) {
				document.getElementsByClassName('v-dialog__content')[0].style.height = '30%';
				document.getElementsByClassName('v-dialog__content')[0].style.bottom = '0';
				document.getElementsByClassName('v-dialog__content')[0].style.top = 'revert';
			}
		},
		touchUp() {
			if (document.querySelector('.v-bottom-sheet') != null) {
				document.querySelector('.v-bottom-sheet').style.height = '90%';
			}
		},
		touchDown() {
			if (document.querySelector('.v-bottom-sheet') != null) {
				document.querySelector('.v-bottom-sheet').style.height = '30%';
			}
		},
		checkBox(index) {
			this.$set(this.isCheckedBox, index, !this.isCheckedBox[index]);
		},
		//------------------------------------
		// Zoom
		handleMouseDown(event) {
			event.preventDefault();
			
			this.isDragging = true;
			this.startX = event.clientX - this.$refs.container.offsetLeft;
			this.startY = event.clientY - this.$refs.container.offsetTop;
		},
		handleMouseMove(event) {
			if (!this.isDragging) return;
			const offsetX = event.clientX - this.startX;
			const offsetY = event.clientY - this.startY;
			this.translateX += offsetX;
			this.translateY += offsetY;
			this.startX = event.clientX;
			this.startY = event.clientY;
			},
		handleMouseUp() {
			this.isDragging = false;
		},
		handleWheel(event) {
			const delta = Math.sign(event.deltaY);
			const scaleFactor = 0.1;
			this.scale -= (delta * scaleFactor);
			this.scale = Math.max(0.6, this.scale);
		},
	}
}
</script>
  
<style lang="scss" scoped>
@import "../styles/common/common.css";
@import "../styles/split-alt.css";

body {
	align-items: flex-start;
	/* 左寄せに設定 */
	height: 100vh;
	/* 画面の高さいっぱいに広がるように */
	padding-left: 10px;
	padding-right: 10px;
	margin: 0;
	/* ボディのマージンをゼロに設定 */
	background-color: #E0E0E0;
	/* グレーの背景色 */
	white-space: nowrap;
	/* テキストを改行させないようにする */
	overflow: hidden;
	/* コンテンツがコンテナをはみ出た場合に隠す */
}

container {
	display: flex;
	justify-content: space-between;
	/* または space-evenly を使用する */
	align-items: flex-start;
	/* 左寄せに設定 */
	flex-direction: row;
	max-width: auto;
	/* 任意の横幅に設定 */
	margin-right: 5px;
	text-align: left;
	/* 左寄せに設定 */
	font-size: 14px;
}

.right-align-container {
	display: flex;
	justify-content: flex-end;
	align-items: center;
	width: 15%;
	/* または必要に応じて調整 */
}

section {
	display: flex;
	justify-content: space-between;
	/* または space-evenly を使用する */
	align-items: flex-start;
	/* 左寄せに設定 */
	flex-direction: column;
	max-width: auto;
	/* 任意の横幅に設定 */
	margin-right: 5px;
	text-align: auto;
	/* 左寄せに設定 */
	font-size: 14px;
}

p {
	background-color: #70d8e4;
	/* 任意の色を指定 */
	width: 100%;
	margin-bottom: 0px;
}

thead {
	background-color: rgb(56, 110, 155);
	color: mintcream;
}

.split {
	//height: 100%;
	height: calc(100% - 12px);
	padding: 6px 0;
}

.right-box {
	right: 0;
	width: 30%;
	//height: 100%;
	height: calc(100% - 24px);
	margin: 4px 0;
	overflow-y: auto;
	background-color: rgb(118, 164, 170);
}

.acceptButton {
	font-size: 2rem;
	padding: 0.5em 1.5em;
}

/*
  .selected {
	background-color: rgb(238, 255, 0);
  }
  */
#selected-plot {
	background-color: lightsteelblue;
	font-size: 1.25rem;
	width: 100%;
	margin: 0.5em 0;
	text-align: center;
}

::v-deep .v-bottom-sheet {
	height: 30%;
}

.v-dialog__content {
	z-index: 2 !important;
}

/* 操作部分 */
.button-background {
	width: 100%;
	justify-content: center;
	background: linear-gradient(to bottom, #b0b0b0, #d1d1d1);
}

.button-container {
	display: flex;
	justify-content: space-between;
	/* アイテムを横方向に左寄せに配置 */
	background: linear-gradient(to bottom, #b0b0b0, #d1d1d1);
	padding: 5px;
}

.button-container-right {
	display: flex;
	justify-content: flex-end;
	margin-left: auto;
	background: linear-gradient(to bottom, #b0b0b0, #d1d1d1);
	padding: 5px;
}

.action-button {
	position: relative;
	background: linear-gradient(to bottom, #d1d1d1, #b0b0b0);
	color: #000000;
	border: 1px solid #808080;
	/* ボーダーのスタイルと色 */
	height: 30px;
	padding-left: 20px;
	/* 左側のpadding */
	padding-right: 20px;
	/* 右側のpadding */
	margin-right: 1px;
	/* 仕切りとの間隔 */
	margin-bottom: 0px;
	/* 下部の余白を解除 */
	display: inline-flex;
	/* インラインフレックスコンテナにする */
	align-items: center;
	/* 垂直方向に中央揃え */
	cursor: pointer;
}

.action-button-head {
	position: relative;
	display: flex;
	/* Flexboxを有効にする */
	justify-content: center;
	/* 水平方向の中央揃え */
	align-items: center;
	/* 垂直方向の中央揃え */
	background: linear-gradient(to bottom, #d1d1d1, #b0b0b0);
	color: #000000;
	border: 1px solid #808080;
	/* ボーダーのスタイルと色 */
	padding: 10px 15px;
	margin-right: 1px;
	/* 仕切りとの間隔 */
	margin-bottom: 0px;
	/* 下部の余白を解除 */
	cursor: pointer;
}

.action-button[disabled] {
	background: linear-gradient(to bottom, #d1d1d1, #b1b1b1);
	color: #8c8c8c;
}		

.action-button::after {
	content: "";
	position: absolute;
	top: 0;
	right: -2px;
	/* 仕切りの太さ */
	height: 100%;
	width: 2px;
	/* 仕切りの幅 */
	background-color: #7a7a7a;
	/* 仕切りの色 */
}

.action-button:hover {
	background-color: #7c7c7c;
	/* カーソルが乗った時の背景色 */
}

.right-slide {
	margin-left: auto;
}

/* テキストボックス */
.textbox {
	background-color: #ffffff;
	width: 100%;
	/* ボックスの幅 */
	height: 26px;
	padding: 10px;
	/* テキストとボックスの内側の余白 */
	border: 1px solid #808080;
	/* ボーダーのスタイルと色 */
	border-radius: 3px;
	/* 角の丸み */
	font-size: 14px;
	/* テキストのサイズ */
	-moz-appearance: textfield;
}

.textbox:focus {
	border-color: #007bff;
	/* フォーカス時のボーダーの色 */
	outline: none;
	/* デフォルトのフォーカス時のアウトラインを無効にする */
}

.textbox[disabled] {
	background-color: #f0f0f0;
	/* ロックされているときの背景色 */
	color: #777;
	/* ロックされているときの文字色 */
	cursor: not-allowed;
	/* ロックされているときのカーソルスタイル */
}

.textbox::-webkit-outer-spin-button,
.textbox::-webkit-inner-spin-button {
	-webkit-appearance: none;
	/* ChromeやSafariでの矢印を非表示にする */
	margin: 0;
	/* 矢印があった場所の余白を取り除く */
}

/* プルダウン */
select {
	width: 100%;
	padding: 4px;
	/* セレクトボックス内のコンテンツと枠の間に余白を作る */
	border: 1px solid #808080;
	/* ボーダーのスタイルと色 */
	background-color: white;
	/* セレクトボックスの背景色を白にする */
	cursor: pointer;
}

select[disabled] {
	background-color: #f0f0f0;
	/* ロックされているときの背景色 */
	color: #777;
	/* ロックされているときの文字色 */
	cursor: not-allowed;
	/* ロックされているときのカーソルスタイル */
}

.custom-select {
	position: relative;
	display: inline-block;
}

.custom-select select {
	min-width: 40px;
	width: 100%;
	padding: 5px;
	font-size: 14px;
	border: 1px solid #808080;
	border-radius: 3px;
	background-color: #fff;
	appearance: none;
	/* デフォルトの矢印を非表示にする */
}

.custom-select::after {
	content: '\25BC';
	/* 下向きの三角矢印のUnicode */
	font-size: 7px;
	position: absolute;
	top: 50%;
	right: 7px;
	transform: translateY(-50%);
	pointer-events: none;
	/* 矢印はクリックイベントを受けないようにする */
}


/* チェックボックス */
.checkbox {
	margin-right: 5px;
}

/* データ入力時の台帳参照ウィンドウ */
.scroll-container {
  width: 100%;
  height: calc(100% - 50px);
  border: 1px solid #808080;
  overflow: auto; /* スクロールバーを有効にする */
  position: relative;
}

.image-wrapper {
  display: inline-block;
}

.full-width-image {
	width: 100%;
	height: 100%;
  height: auto;
  position: absolute;
	margin: 0 auto;
	object-fit: contain; /* 縦横比を保って表示 */
}

.fullscreen-dialog {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
}

.fullscreen-content {
  text-align: center;
}

.fullscreen-image {
  max-width: 100%;
  max-height: 100%;
}

/* ラストコンテント */
.last-content {
	margin-right: 0;
	/* 最後のコンテンツに対して margin-right を無効にする */
}
</style>
  
